import { createContext } from 'react';

type PredicionMapContextType = {
  sliderValue: number;
  setSliderValue: React.Dispatch<React.SetStateAction<number>>;
  calculatedTime: Date | null;
  setCalculatedTime: React.Dispatch<React.SetStateAction<Date | null>>;
  imageIdList: string[];
};

const PredicionMapContext = createContext<PredicionMapContextType>({} as PredicionMapContextType);

export default PredicionMapContext;
